import { Link } from "react-router-dom";
import { Ship } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-navy text-white/70 border-t border-white/10 mt-24">
      <div className="max-w-[1400px] mx-auto px-6 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2.5 mb-4">
            <div className="h-9 w-9 bg-cyan flex items-center justify-center rounded-sm">
              <Ship className="h-5 w-5 text-navy" />
            </div>
            <span className="font-heading font-extrabold text-lg text-white">VK Forwarders</span>
          </div>
          <p className="text-sm leading-relaxed text-white/50">
            Planning Logistics, Moving Cargo, Delivering Trust. A technology-enabled freight forwarding
            partner for exporters and importers.
          </p>
        </div>
        <div>
          <h4 className="text-white text-sm font-semibold mb-4">Rates</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/rates?shipment_type=export" className="hover:text-signal transition-colors">Export Freight Rates</Link></li>
            <li><Link to="/rates?shipment_type=import" className="hover:text-signal transition-colors">Import Freight Rates</Link></li>
            <li><Link to="/trade-lane/india-to-dubai" className="hover:text-signal transition-colors">India to Dubai Rates</Link></li>
            <li><Link to="/trade-lane/india-to-europe" className="hover:text-signal transition-colors">India to Europe Rates</Link></li>
            <li><Link to="/trade-lane/india-to-usa" className="hover:text-signal transition-colors">India to USA Rates</Link></li>
            <li><Link to="/shipping-lines" className="hover:text-signal transition-colors">Shipping Lines</Link></li>
            <li><Link to="/local-charges" className="hover:text-signal transition-colors">Local Charges</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white text-sm font-semibold mb-4">Tools</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/calculator" className="hover:text-signal transition-colors">Shipment Calculator</Link></li>
            <li><Link to="/enquiry" className="hover:text-signal transition-colors">Plan a Shipment</Link></li>
            <li><Link to="/dashboard" className="hover:text-signal transition-colors">Customer Dashboard</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white text-sm font-semibold mb-4">Company</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/about" className="hover:text-signal transition-colors">About Us</Link></li>
            <li><Link to="/contact" className="hover:text-signal transition-colors">Contact Us</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-white/40">
        © {new Date().getFullYear()} VK Forwarders. Rates are indicative and subject to final confirmation at booking.
      </div>
    </footer>
  );
}
